<div class="my-account-page">
  <div class="page-header">
    <h2>My Account</h2>
    <!-- <button nz-button nzSize="small" (click)="refreshUser()" [nzLoading]="loading">Refresh</button> -->
  </div>

  <div class="account-grid">
    <nz-card class="badge-card">
      <div class="badge-image" *ngIf="badgeUrl; else badgePlaceholder">
        <img [src]="badgeUrl" alt="Badge image" />
      </div>
      <ng-template #badgePlaceholder>
        <div class="badge-placeholder">No badge photo yet</div>
      </ng-template>
      <!-- let user upload new badge photo -->
      <div class="meta-line center-it">
        <button
          nz-button
          nzType="default"
          nzDanger
          nzShape="round"
          nzSize="small"
          (click)="openBadgeUpload()"
        >
          <span nz-icon nzType="upload" nzTheme="outline"></span>
          Upload Badge Photo
        </button>
      </div>
      <div class="meta-line">
        <span class="label">User ID</span>
        <span class="value">{{ crmId || "N/A" }}</span>
      </div>
      <div class="meta-line" *ngFor="let item of providerExternals">
        <span class="label">{{ item.providerName }} External ID</span>
        <span class="value">{{ item.externalId }}</span>
      </div>
    </nz-card>

    <nz-card class="info-card">
      <div class="info-row">
        <span class="label">Name</span>
        <span class="value">{{
          fullName ? (fullName | titlecase) : "Not set"
        }}</span>
      </div>
      <div class="info-row">
        <span class="label">Email</span>
        <span class="value">{{ user?.email || "Not set" }}</span>
      </div>
      <div class="info-row">
        <span class="label">Phone</span>
        <span class="value">{{ user?.phone || "Not set" }}</span>
      </div>
      <div class="info-row">
        <span class="label">Address</span>
        <span class="value address-value">{{
          user?.address || "Not set"
        }}</span>
      </div>
    </nz-card>
  </div>

  <nz-card class="providers-card">
    <div class="providers-card__header">
      <div class="card-title">Providers you can sell</div>
      <button
        nz-button
        nzType="default"
        nzSize="small"
        (click)="openRequestProviderModal()"
        [nzLoading]="requestProviderLoading"
      >
        <span nz-icon nzType="plus"></span>
        Request Provider
      </button>
    </div>
    <div class="providers-list" *ngIf="providerList.length; else noProviders">
      <nz-tag *ngFor="let p of providerList">{{ p?.name || p }}</nz-tag>
    </div>
    <ng-template #noProviders>
      <div class="empty-copy">No providers assigned</div>
    </ng-template>
  </nz-card>

  <nz-modal
    [(nzVisible)]="requestProviderModal"
    nzTitle="Request Provider"
    (nzOnCancel)="closeRequestProviderModal()"
    (nzOnOk)="submitProviderRequest()"
    [nzOkLoading]="requestProviderLoading"
  >
    <ng-container *nzModalContent>
      <form [formGroup]="requestProviderForm">
        <nz-form-item>
          <nz-form-label>Provider</nz-form-label>
          <nz-select
            style="width: 100%"
            nzMode="multiple"
            nzAllowClear
            nzShowSearch
            nzPlaceHolder="Select providers to request"
            formControlName="provider_ids"
            [nzLoading]="requestProviderLoading"
          >
            <nz-option
              *ngFor="let p of availableProviders"
              [nzLabel]="p.name"
              [nzValue]="p.id"
            ></nz-option>
          </nz-select>
        </nz-form-item>
      </form>
    </ng-container>
  </nz-modal>

  <nz-modal
    [(nzVisible)]="badgeUploadModal"
    nzTitle="Upload Badge Photo"
    (nzOnCancel)="closeBadgeUploadModal()"
    (nzOnOk)="submitBadgeUpload()"
  >
    <ng-container *nzModalContent>
      <form [formGroup]="badgeUploadForm">
        <nz-form-item>
          <nz-form-label>Badge Photo</nz-form-label>
          <nz-form-control>
            <input
              nz-input
              type="file"
              formControlName="badge_photo"
              (change)="onBadgeFileSelected($event)"
            />
          </nz-form-control>
        </nz-form-item>
      </form>
    </ng-container>
  </nz-modal>
</div>
